import { useEffect } from 'react';
import globalEvents from '@/utils/globalEvents';
import { deleteUndefinedValues } from '@/common/utils/objects';

const useGlobalSectionEditing = _ref => {
  let {
    onChange
  } = _ref;
  useEffect(() => {
    return globalEvents.subscribe('activeSectionEdit', evt => {
      if (typeof onChange === 'function') {
        var _evt$detail, _evt$detail2, _evt$detail3, _evt$detail4;

        onChange('', deleteUndefinedValues({
          title: evt === null || evt === void 0 ? void 0 : (_evt$detail = evt.detail) === null || _evt$detail === void 0 ? void 0 : _evt$detail.title,
          titleAttrs: evt === null || evt === void 0 ? void 0 : (_evt$detail2 = evt.detail) === null || _evt$detail2 === void 0 ? void 0 : _evt$detail2.titleAttrs,
          subHeading: evt === null || evt === void 0 ? void 0 : (_evt$detail3 = evt.detail) === null || _evt$detail3 === void 0 ? void 0 : _evt$detail3.subHeading,
          subHeadingAttrs: evt === null || evt === void 0 ? void 0 : (_evt$detail4 = evt.detail) === null || _evt$detail4 === void 0 ? void 0 : _evt$detail4.subHeadingAttrs
        }));
      }
    });
  }, [onChange]);
};

export default useGlobalSectionEditing;